var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#1F2937"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 12H23C24.1046 12 25 12.8954 25 14V20C25 21.1046 24.1046 22 23 22H21V26L17 22H13C12.4477 22 11.9477 21.7761 11.5858 21.4142M11.5858 21.4142L15 18H19C20.1046 18 21 17.1046 21 16V10C21 8.89543 20.1046 8 19 8H9C7.89543 8 7 8.89543 7 10V16C7 17.1046 7.89543 18 9 18H11V22L11.5858 21.4142Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiChat);
export default __webpack_public_path__ + "static/media/AiChat.0bddb1c83d50f27b3f591db410eb968d.svg";
export { ForwardRef as ReactComponent };